import { ColorsVariations } from 'const/colors';
import { StatusColor } from 'types/Status';

export const StatusColors: { [key: string]: StatusColor } = {
  Rouge: {
    bg: ColorsVariations['rouge-copro-1'],
    border: ColorsVariations['rouge-copro-6'],
    text: ColorsVariations['rouge-copro-9'],
  },
  BleuHellio: {
    bg: ColorsVariations['bleu-hellio-1'],
    border: ColorsVariations['bleu-hellio-6'],
    text: ColorsVariations['bleu-hellio-10'],
  },
  BleuEntreprises: {
    bg: ColorsVariations['bleu-entreprises-1'],
    border: ColorsVariations['bleu-entreprises-6'],
    text: ColorsVariations['bleu-entreprises-6'],
  },
  Orange: {
    bg: ColorsVariations['orange-particuliers-1'],
    border: ColorsVariations['orange-particuliers-6'],
    text: ColorsVariations['orange-particuliers-10'],
  },
  Rose: {
    bg: ColorsVariations['rose-collectivites-1'],
    border: ColorsVariations['rose-collectivites-6'],
    text: ColorsVariations['rose-collectivites-10'],
  },
  Marron: {
    bg: ColorsVariations['marron-pros-1'],
    border: ColorsVariations['marron-pros-6'],
    text: ColorsVariations['marron-pros-6'],
  },
  Vert: {
    bg: ColorsVariations['vert-transport-1'],
    border: ColorsVariations['vert-transport-6'],
    text: ColorsVariations['vert-transport-10'],
  },
  VertPlein: {
    bg: ColorsVariations['vert-transport-4'],
    border: ColorsVariations['vert-transport-6'],
    text: ColorsVariations['gris-hellio-6'],
  },
  Gris: {
    bg: ColorsVariations['gris-industriels-1'],
    border: ColorsVariations['gris-industriels-6'],
    text: ColorsVariations['gris-hellio-6'],
  },
  Violet: {
    bg: ColorsVariations['violet-1'],
    border: ColorsVariations['violet-6'],
    text: ColorsVariations['violet-10'],
  },
};

export default StatusColors;
